import React from 'react'
import Home from './components/Home'

const HomeConnect = () => {
  return (
    <Home />
  )
}

export default HomeConnect